<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="unitForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="unit" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                unitForm: () => import('../forms/UnitForm'),
                unit: () => import('../editViews/Unit'),
                headers: [
                    { text: 'Name', value: 'name' },
                    { text: 'Prefix', value: 'prefix' },
                    { text: 'Suffix', value: 'suffix' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    items: []
                },
                sorting: [
                    { column: "name", direction: "ascending" },
                ],
                itemsField: 'units',
                editPageName: 'unit',
                apiMethod: 'Units',
                claimName: 'Units',
                formTitle: 'Unit',
                excelTitle: 'Units',
                hasEditPage: true,
            }
        },
    };
</script>
